import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommChevronRightIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M8.23431 6.32775C7.9219 6.02401 7.9219 5.53155 8.23431 5.22781C8.54673 4.92406 9.05327 4.92406 9.36568 5.22781L15.7657 11.45C16.0781 11.7538 16.0781 12.2462 15.7657 12.55L9.36568 18.7722C9.05327 19.0759 8.54673 19.0759 8.23431 18.7722C7.9219 18.4685 7.9219 17.976 8.23431 17.6723L14.0686 12L8.23431 6.32775Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
